<!-- Slide-over Panel Backdrop -->
<div class="fixed inset-0 z-[9999] flex justify-end" role="dialog" aria-modal="true" aria-label="Acciones del negocio">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-gray-900/50 backdrop-blur-[1px]" (click)="close.emit()"></div>

  <!-- Panel -->
  <div class="relative w-full max-w-lg bg-white shadow-2xl dark:bg-gray-900">
    <div class="flex h-full flex-col">
      <!-- Header -->
      <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-800">
        <div class="flex items-center gap-3">
          <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-50 text-sm font-bold text-brand-600 dark:bg-brand-500/10 dark:text-brand-400">
            {{ business.name.charAt(0).toUpperCase() }}
          </div>
          <div>
            <h2 class="text-base font-semibold text-gray-900 dark:text-white">{{ business.name }}</h2>
            <p class="text-xs text-gray-500 dark:text-gray-400">ID: {{ business.businessId | slice:0:8 }}...</p>
          </div>
        </div>
        <button (click)="close.emit()" class="rounded-lg p-2 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-200" aria-label="Cerrar panel">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <!-- Tabs -->
      <div class="flex border-b border-gray-200 px-6 dark:border-gray-800">
        <button (click)="activeTab.set('info')" [class.border-brand-500]="activeTab() === 'info'" [class.text-brand-600]="activeTab() === 'info'"
          class="border-b-2 border-transparent px-4 py-3 text-sm font-medium text-gray-600 transition hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
          Información
        </button>
        <button (click)="activeTab.set('membership')" [class.border-brand-500]="activeTab() === 'membership'" [class.text-brand-600]="activeTab() === 'membership'"
          class="border-b-2 border-transparent px-4 py-3 text-sm font-medium text-gray-600 transition hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
          Membresía
        </button>
        <button (click)="activeTab.set('danger')" [class.border-error-500]="activeTab() === 'danger'" [class.text-error-600]="activeTab() === 'danger'"
          class="border-b-2 border-transparent px-4 py-3 text-sm font-medium text-gray-600 transition hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
          Zona Peligrosa
        </button>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto px-6 py-5">

        <!-- Info Tab -->
        @if (activeTab() === 'info') {
        <div class="space-y-4">
          <div class="rounded-xl border border-gray-200 p-4 dark:border-gray-800">
            <h3 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-300">Detalles del Negocio</h3>
            <dl class="space-y-3">
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Estado</dt>
                <dd>
                  <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                    [class]="business.isActive ? 'bg-success-50 text-success-700 dark:bg-success-500/10 dark:text-success-400' : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400'">
                    {{ business.isActive ? 'Activo' : 'Inactivo' }}
                  </span>
                </dd>
              </div>
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Fecha de creación</dt>
                <dd class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDate(business.createdAt) }}</dd>
              </div>
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Membresía</dt>
                <dd class="text-sm font-medium text-gray-900 dark:text-white">{{ business.membershipStatus || 'Sin membresía' }}</dd>
              </div>
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Plan</dt>
                <dd class="text-sm font-medium text-gray-900 dark:text-white">{{ business.membershipPlanName || 'N/A' }}</dd>
              </div>
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Inicio membresía</dt>
                <dd class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDate(business.membershipStartDate) }}</dd>
              </div>
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Vencimiento</dt>
                <dd class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDate(business.membershipEndDate) }}</dd>
              </div>
              @if (business.trialStartDate) {
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-500 dark:text-gray-400">Periodo de prueba</dt>
                <dd class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDate(business.trialStartDate) }} - {{ formatDate(business.trialEndDate) }}</dd>
              </div>
              }
            </dl>
          </div>
        </div>
        }

        <!-- Membership Tab -->
        @if (activeTab() === 'membership') {
        <div class="space-y-5">

          <!-- No membership - Assign -->
          @if (!hasMembership) {
          <div class="rounded-xl border border-amber-200 bg-amber-50/50 p-4 dark:border-amber-500/30 dark:bg-amber-500/5">
            <div class="flex items-center gap-2 mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-amber-600 dark:text-amber-400">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <h3 class="text-sm font-semibold text-amber-700 dark:text-amber-400">Sin membresía activa</h3>
            </div>
            <p class="text-xs text-amber-600 dark:text-amber-400/80">Este negocio no tiene una membresía asignada. Asigna un plan para habilitarlo.</p>
          </div>

          <div class="rounded-xl border border-gray-200 p-4 dark:border-gray-800">
            <h3 class="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">Asignar Membresía</h3>
            <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">Selecciona un plan y fecha de vencimiento para este negocio</p>

            @if (plansLoading()) {
            <div class="flex items-center justify-center py-6">
              <div class="h-5 w-5 animate-spin rounded-full border-2 border-brand-500 border-t-transparent"></div>
              <span class="ml-2 text-sm text-gray-500">Cargando planes...</span>
            </div>
            } @else {
            <div class="space-y-4">
              <div>
                <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Plan de membresía</label>
                <select [(ngModel)]="selectedPlanId"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 transition focus:border-brand-500 focus:ring-1 focus:ring-brand-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
                  aria-label="Plan de membresía">
                  <option value="">Seleccionar plan...</option>
                  @for (plan of membershipPlans(); track plan.membershipPlanId) {
                  <option [value]="plan.membershipPlanId">{{ plan.name }} - ${{ plan.priceMonthly }}/mes</option>
                  }
                </select>
              </div>
              <div>
                <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Fecha de vencimiento</label>
                <input type="date" [(ngModel)]="assignEndDate"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                  aria-label="Fecha de vencimiento" />
              </div>
              <button (click)="onAssignMembership()" [disabled]="loading() || !selectedPlanId || !assignEndDate"
                class="w-full rounded-lg bg-brand-500 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-brand-600 disabled:opacity-50">
                @if (loading()) {
                  <span class="animate-pulse">Asignando membresía...</span>
                } @else {
                  Asignar Membresía
                }
              </button>
            </div>
            }
          </div>

          } @else {
          <!-- Has membership - Extend / Set Date -->

          <!-- Current Status -->
          <div class="rounded-xl border p-4"
            [class]="business.membershipStatus === 'Vencida'
              ? 'border-error-200 bg-error-50/50 dark:border-error-500/30 dark:bg-error-500/5'
              : business.membershipStatus === 'En Período de Prueba'
                ? 'border-amber-200 bg-amber-50/50 dark:border-amber-500/30 dark:bg-amber-500/5'
                : 'border-success-200 bg-success-50/50 dark:border-success-500/30 dark:bg-success-500/5'">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Estado actual</p>
                <p class="text-sm font-semibold"
                  [class]="business.membershipStatus === 'Vencida'
                    ? 'text-error-700 dark:text-error-400'
                    : business.membershipStatus === 'En Período de Prueba'
                      ? 'text-amber-700 dark:text-amber-400'
                      : 'text-success-700 dark:text-success-400'">
                  {{ business.membershipStatus }}
                </p>
              </div>
              <div class="text-right">
                <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Plan</p>
                <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ business.membershipPlanName || 'N/A' }}</p>
              </div>
            </div>
            @if (business.membershipEndDate || business.trialEndDate) {
            <div class="mt-2 border-t border-gray-200/50 pt-2 dark:border-gray-700/50">
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Vencimiento: <span class="font-medium text-gray-700 dark:text-gray-300">{{ formatDate(business.membershipEndDate || business.trialEndDate) }}</span>
              </p>
            </div>
            }
          </div>

          <!-- Extend Membership -->
          <div class="rounded-xl border border-gray-200 p-4 dark:border-gray-800">
            <h3 class="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">Extender Membresía</h3>
            <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">Agrega días adicionales a la membresía actual</p>
            <div class="flex items-end gap-3">
              <div class="flex-1">
                <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Días a agregar</label>
                <input type="number" [(ngModel)]="extensionDays" min="1" max="365"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                  aria-label="Días de extensión" />
              </div>
              <button (click)="onExtendMembership()" [disabled]="loading()"
                class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:opacity-50">
                @if (loading()) {
                  <span class="animate-pulse">Procesando...</span>
                } @else {
                  Extender
                }
              </button>
            </div>
          </div>

          <!-- Set End Date -->
          <div class="rounded-xl border border-gray-200 p-4 dark:border-gray-800">
            <h3 class="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">Modificar Fecha de Vencimiento</h3>
            <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">Establece una nueva fecha de vencimiento para la membresía</p>
            <div class="flex items-end gap-3">
              <div class="flex-1">
                <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Nueva fecha</label>
                <input type="date" [(ngModel)]="newEndDate"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                  aria-label="Nueva fecha de vencimiento" />
              </div>
              <button (click)="onSetMembershipEndDate()" [disabled]="loading()"
                class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:opacity-50">
                @if (loading()) {
                  <span class="animate-pulse">Procesando...</span>
                } @else {
                  Aplicar
                }
              </button>
            </div>
          </div>

          <!-- Change Plan (Upgrade / Downgrade) -->
          <div class="rounded-xl border border-gray-200 p-4 dark:border-gray-800">
            <h3 class="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">Cambiar Plan</h3>
            <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">Upgrade o downgrade del plan actual. La membresía anterior se cierra en la fecha de transición.</p>

            @if (!showChangePlan()) {
            <button (click)="onOpenChangePlan()"
              class="rounded-lg border border-brand-300 bg-white px-4 py-2 text-sm font-medium text-brand-700 transition hover:bg-brand-50 dark:border-brand-500/30 dark:bg-gray-900 dark:text-brand-400 dark:hover:bg-brand-500/10">
              Cambiar plan
            </button>
            } @else {
            <div class="space-y-4">

              <!-- Current plan info -->
              <div class="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-800/50">
                <p class="text-xs text-gray-500 dark:text-gray-400">Plan actual</p>
                <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ business.membershipPlanName || 'Sin plan' }}</p>
              </div>

              @if (plansLoading()) {
              <div class="flex items-center justify-center py-4">
                <div class="h-5 w-5 animate-spin rounded-full border-2 border-brand-500 border-t-transparent"></div>
                <span class="ml-2 text-sm text-gray-500">Cargando planes...</span>
              </div>
              } @else if (!showChangePlanConfirm()) {
              <!-- Form step -->
              <div>
                <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Nuevo plan</label>
                <select [(ngModel)]="changePlanId"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 transition focus:border-brand-500 focus:ring-1 focus:ring-brand-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
                  aria-label="Nuevo plan de membresía">
                  <option value="">Seleccionar plan...</option>
                  @for (plan of availablePlansForChange(); track plan.membershipPlanId) {
                  <option [value]="plan.membershipPlanId">{{ plan.name }} - ${{ plan.priceMonthly }}/mes ({{ plan.numberOfProfessionals }} prof.)</option>
                  }
                </select>
              </div>
              <div>
                <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Fecha de transición</label>
                <p class="mb-1 text-[11px] text-gray-400 dark:text-gray-500">La membresía actual se cierra en esta fecha y el nuevo plan inicia</p>
                <input type="date" [(ngModel)]="changeTransitionDate"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                  aria-label="Fecha de transición" />
              </div>
              <div>
                <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Vencimiento del nuevo plan</label>
                <input type="date" [(ngModel)]="changeNewEndDate"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                  aria-label="Fecha de vencimiento del nuevo plan" />
              </div>
              <div class="flex gap-2">
                <button (click)="onCancelChangePlan()"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                  Cancelar
                </button>
                <button (click)="onRequestChangePlan()" [disabled]="!changePlanId || !changeTransitionDate || !changeNewEndDate"
                  class="flex-1 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:opacity-50">
                  Revisar cambio
                </button>
              </div>

              } @else {
              <!-- Confirmation step -->
              <div class="rounded-lg border border-amber-200 bg-amber-50/50 p-3 dark:border-amber-500/30 dark:bg-amber-500/5">
                <p class="mb-2 text-sm font-medium text-amber-700 dark:text-amber-400">Confirmar cambio de plan</p>
                <dl class="space-y-1.5 text-xs">
                  <div class="flex justify-between">
                    <dt class="text-gray-500 dark:text-gray-400">Plan actual:</dt>
                    <dd class="font-medium text-gray-700 dark:text-gray-300">{{ business.membershipPlanName || 'Sin plan' }}</dd>
                  </div>
                  <div class="flex justify-between">
                    <dt class="text-gray-500 dark:text-gray-400">Nuevo plan:</dt>
                    <dd class="font-medium text-brand-600 dark:text-brand-400">{{ selectedChangePlanName }}</dd>
                  </div>
                  <div class="flex justify-between">
                    <dt class="text-gray-500 dark:text-gray-400">Fecha de transición:</dt>
                    <dd class="font-medium text-gray-700 dark:text-gray-300">{{ formatDate(changeTransitionDate) }}</dd>
                  </div>
                  <div class="flex justify-between">
                    <dt class="text-gray-500 dark:text-gray-400">Nuevo vencimiento:</dt>
                    <dd class="font-medium text-gray-700 dark:text-gray-300">{{ formatDate(changeNewEndDate) }}</dd>
                  </div>
                </dl>
              </div>
              <div class="flex gap-2">
                <button (click)="showChangePlanConfirm.set(false)"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                  Volver
                </button>
                <button (click)="onConfirmChangePlan()" [disabled]="loading()"
                  class="flex-1 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:opacity-50">
                  @if (loading()) {
                    <span class="animate-pulse">Procesando...</span>
                  } @else {
                    Confirmar cambio de plan
                  }
                </button>
              </div>
              }
            </div>
            }
          </div>
          }

        </div>
        }

        <!-- Danger Zone Tab -->
        @if (activeTab() === 'danger') {
        <div class="space-y-5">
          <!-- Reset Business -->
          <div class="rounded-xl border border-error-200 bg-error-50/50 p-4 dark:border-error-500/30 dark:bg-error-500/5">
            <h3 class="mb-1 text-sm font-semibold text-error-700 dark:text-error-400">Reiniciar Negocio</h3>
            <p class="mb-4 text-xs text-gray-600 dark:text-gray-400">
              Elimina todas las citas, ventas, clientes, productos, servicios, promociones y profesionales.
              Mantiene la configuración principal, owner y membresía.
            </p>
            @if (!showResetConfirm()) {
            <button (click)="showResetConfirm.set(true)"
              class="rounded-lg border border-error-300 bg-white px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-500/30 dark:bg-gray-900 dark:text-error-400 dark:hover:bg-error-500/10">
              Reiniciar negocio
            </button>
            } @else {
            <div class="mt-3 rounded-lg border border-error-200 bg-white p-4 dark:border-error-500/20 dark:bg-gray-900">
              <p class="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                Escribe el nombre del negocio para confirmar: <strong class="text-error-600">{{ business.name }}</strong>
              </p>
              <input type="text" [(ngModel)]="resetConfirmText" placeholder="Nombre del negocio"
                class="mb-3 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                aria-label="Confirmar nombre del negocio" />
              <div class="flex gap-2">
                <button (click)="showResetConfirm.set(false); resetConfirmText = ''"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                  Cancelar
                </button>
                <button (click)="onResetBusiness()" [disabled]="dangerLoading() || resetConfirmText !== business.name"
                  class="rounded-lg bg-error-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-error-700 disabled:opacity-50">
                  @if (dangerLoading()) {
                    <span class="animate-pulse">Procesando...</span>
                  } @else {
                    Confirmar reinicio
                  }
                </button>
              </div>
            </div>
            }
          </div>

          <!-- Delete Business -->
          <div class="rounded-xl border border-error-200 bg-error-50/50 p-4 dark:border-error-500/30 dark:bg-error-500/5">
            <h3 class="mb-1 text-sm font-semibold text-error-700 dark:text-error-400">Eliminar Negocio</h3>
            <p class="mb-4 text-xs text-gray-600 dark:text-gray-400">
              Realiza una eliminación lógica (soft delete) del negocio. Los datos se mantienen pero el negocio
              dejará de ser accesible. Esta acción es irreversible desde la interfaz.
            </p>
            @if (!showDeleteConfirm()) {
            <button (click)="showDeleteConfirm.set(true)"
              class="rounded-lg border border-error-300 bg-white px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-500/30 dark:bg-gray-900 dark:text-error-400 dark:hover:bg-error-500/10">
              Eliminar negocio
            </button>
            } @else {
            <div class="mt-3 rounded-lg border border-error-200 bg-white p-4 dark:border-error-500/20 dark:bg-gray-900">
              <p class="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                Escribe <strong class="text-error-600">ELIMINAR</strong> para confirmar la eliminación permanente.
              </p>
              <input type="text" [(ngModel)]="deleteConfirmText" placeholder="Escribe ELIMINAR"
                class="mb-3 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                aria-label="Confirmar eliminación" />
              <div class="flex gap-2">
                <button (click)="showDeleteConfirm.set(false); deleteConfirmText = ''"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                  Cancelar
                </button>
                <button (click)="onDeleteBusiness()" [disabled]="dangerLoading() || deleteConfirmText !== 'ELIMINAR'"
                  class="rounded-lg bg-error-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-error-700 disabled:opacity-50">
                  @if (dangerLoading()) {
                    <span class="animate-pulse">Procesando...</span>
                  } @else {
                    Eliminar permanentemente
                  }
                </button>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
